module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVRYhe3XsQmAQAxG4R9xAEdwFEfRDdzIVdzAlSy0EAIWIWqC7ytT3D24JicAqG3IXr9JWsw0kY7IIERGITIKkVHqR7Zmchgl9Wb6nFXSfJ4+XW9pXowo6/aJv0acF3FexHkR55V+GUi/TqX/uAP4N0k7wMAjTP41U74AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_arrow_bk.png
// module id = 1085
// module chunks = 0